import { render, staticRenderFns } from "./admin-cuentas.vue?vue&type=template&id=93f17f9c&scoped=true"
import script from "./admin-cuentas.vue?vue&type=script&lang=js"
export * from "./admin-cuentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f17f9c",
  null
  
)

export default component.exports